import { render, staticRenderFns } from "./courseIntro.vue?vue&type=template&id=c5449c18&scoped=true"
import script from "./courseIntro.vue?vue&type=script&lang=ts"
export * from "./courseIntro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5449c18",
  null
  
)

export default component.exports